import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  ListGroupItem,
  CustomInput,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import axios from 'axios'
import shortid from 'shortid'
import 'video-react/dist/video-react.css'; // import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UploadAudioDiv from './DemoUploadAudioDiv'
import * as MyAPI from '../../../utils/MyAPI'
import DemoEditor from './DemoEditor'
import soundwave from '../../../images/72459-sownd-wave.gif'
import * as UserActions from '../../../actions/UserActions'
import { RecordRTCPromisesHandler }  from 'recordrtc'
import RecordRTC  from 'recordrtc'
import AudioController from './AudioController'
import { Buffer } from 'buffer';

let myRecorder = null

// AudioMagicEditor
const AudioMagicEditor = (props) => {

  let dispatch = useDispatch();

  // use refs
  let playerRef = useRef(null)
  let editorPositionRef = useRef(null)
  let editorRef = useRef();
  let widthRef = useRef(null)

  // // stream
  // let myStreams = useSelector(state => {
  //   if (state.user && state.user.streams) {
  //     return state.user.streams
  //   } else {
  //     return null
  //   }
  // });

  let [selectedFile, setSelectedFile] = useState(null);
  let [mediaUrl, setMediaUrl] = useState("")
  let [myBlob, setMyBlob] = useState(null)
  // let [videoExpandFlg, setVideoExpandFlg] = useState(false)
  let [isPlaying, setIsPlaying] = useState(false)
  let [transcriptDraftjsRaw, setTranscriptDraftjsRaw] = useState({
    blocks: [],
    entityMap: {},
  })
  let [transcribed, setTranscribed] = useState(false)

  let [playIconStopFlg, setPlayIconStopFlg] = useState(false)
  let [playIconStartTime, setPlayIconStartTime] = useState(0)
  let [playIconStartIndex, setPlayIconStartIndex] = useState(0)
  let [playIconStartTexts, setPlayIconStartTexts] = useState("")
  let [playIconStartDiff, setPlayIconStartDiff] = useState(null)
  // let [playIconEndTime, setPlayIconEndTime] = useState(5)
  let [playIconMarginTop, setPlayIconMarginTop] = useState(26)
  let [mojiokoCount, setMojiokoCount] = useState(0)

  let [blockTimes, setBlockTimes] = useState([])
  let [playingBlockIndex, setPlayingBlockIndex] = useState(0)
  let [playerCurrentTime, setPlayerCurrentTime] = useState(0)

  // record voice
  let [recording, setRecording] = useState(false)
  let [recordingStatus, setRecordingStatus] = useState("none")
  let [videoStreamType, setVideoStreamType] = useState("mic")
  let [startTimestamp, setStartTimestamp] = useState(-1)
  let [audioDuration, setAudioDuration] = useState(0) // actually used only when voice is recorded
  // let [videoDisplayType, setVideoDisplayType] = useState("none")
  let [myStreams, setMyStreams] = useState(null)

  // componentDidMount > cleanup not working...
  useEffect(() => {

    return () => {

      if (recording === true) {
        myRecorder.stopRecording()
      }

      if (myStreams && myStreams.length > 0) {
        for ( let i=0; i<myStreams.length; i++ ) {
          let _stream = myStreams[i]

          _stream.getTracks().forEach(function(track) {
            track.stop()
          })
        }
      }

      myRecorder = null
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // // componentDidMount > cleanup not working...
  // useEffect(() => {
  //
  //
  //   if (playerRef.current) {
  //     console.log(playerRef.current.state.abc)
  //   }
  //
  //   return () => {
  //     console.log("cleaned up 22");
  //   };
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [playerRef.current]);

  // handle selected file
  let _fileSlected = async (acceptedFiles) => {

    if (acceptedFiles.length !== 1) {
      props.showAlert("音声ファイルは一つずつアップロードして頂けますでしょうか。", "info")
      return
    }

    let _selectedFile = acceptedFiles[0]
    setSelectedFile(_selectedFile)

    let _tmp_path =  URL.createObjectURL(_selectedFile)
    setMediaUrl(_tmp_path)

    let blob = await fetch(_tmp_path).then(r => r.blob());
    setMyBlob(blob)
  }

  // convert blob into base64
  let _convertBlob2Base64 = (blob) => {

    return new Promise(function(resolve, reject) {

      var reader = new FileReader();
      reader.readAsArrayBuffer(blob)

      reader.onloadend = function() {
        var data = reader.result;
        let _buffer = new Buffer(data);
        resolve(_buffer.toString("base64"))
      }

    })
  }

  // send audio to api server directly...
  let _transcribe2 = async () => {

    // duration check
    let _duration = playerRef.current.getDuration();

    if ( isFinite(_duration) === false ) {
      _duration = audioDuration
    }

    if (audioDuration !== 0) {
      if ( _duration < 5 ) {
        props.showAlert("音声が短過ぎます。音声は5秒以上、60分未満でお願いします。", "info")
        return
      } else if ( _duration > 60*60 ) {
        props.showAlert("音声が長過ぎます。音声は5秒以上、60分未満でお願いします。", "info")
        return
      }
    }

    props.setLoading(true)

    try {

      // dictinary is applied automatically
      let _mini_dict = []

      let api_key = ""
      let api_url = "https://asr1.shabelab.com/transcribe"

      for ( let i=0; i<props.deepSpeechTokens.length; i++ ) {
        let _item = props.deepSpeechTokens[i]
        if (_item._id === props.apiIdSelected) {
          api_key = _item.api_key
          api_url = _item.api_url
          break
        }
      }

      if (!api_key || !api_url) {
        props.showAlert("api key not deteced.", "error")
        return;
      }

      // myBlob
      let base64 = await _convertBlob2Base64(myBlob)

      let response_type = "v2"
      if (props.response_type) {
        response_type = props.response_type
      }


      let results = await _transcribeBase64(api_key, api_url, base64, _mini_dict, response_type)

      // make draftjs

      let transcript_draftjs_raw = {
        blocks: [],
        entityMap: {},
      }

      if (results && results.length > 0) {
        // transcript = results[0].alternatives[0].transcript
        for (let i=0; i<results.length; i++) {

          let _transcript = results[i].alternatives[0].transcript
          let _startTime = results[i].alternatives[0].startTime
          let _endTime = results[i].alternatives[0].endTime

          if (_transcript) {

            let _key = shortid.generate()

            let _word_count = _transcript.trim().length

            transcript_draftjs_raw.blocks.push({
              depth:0,
              data: {
                'time0': _startTime+"~"+_endTime+"@0-"+_word_count,
              },
              entityRanges: [],
              inlineStyleRanges: [],
              key: _key,
              text: _transcript.trim(),
              type: "unstyled",
            })
          }
        }
      }

      // set transcript_draftjs_raw
      setTranscriptDraftjsRaw(transcript_draftjs_raw)

      // set transcribed true
      setTranscribed(true)

      props.showAlert("OK", "success")

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)
  }

  // transcribe local file
  let _transcribeBase64 = async (api_key, api_url, audio_base64, mini_dictionary, response_type) => {

    try {

      let results_1 = await axios.post(api_url, {
        audio: audio_base64,
        response_type: response_type,
        stereo: false,
        get_timestamps: false,
        mini_dictionary: mini_dictionary,
      }, {
        headers: {
          'Accept': 'application/json',
          'Authorization': api_key,
        },
      })
      let _results_2 = null
      if (results_1.data) {
        _results_2 = results_1.data
      }

      if (_results_2.status !== 'success') {
        throw Error(_results_2.message)
      }

      let _results_3 = _results_2.results

      return _results_3

    } catch (err) {
      throw Error(err.message)
    }
  }

  // pause media
  let _togglePlayMedia = () => {

    if (!playerRef || !playerRef.current) {
      return
    }

    // const { player } = playerRef.current.getState();

    if (isPlaying === false) {
      _playMedia()
      // setIsPlaying(true)
    } else {
      playerRef.current.pauseAudio()
      setIsPlaying(false)
    }
  }

  let _playMedia2 = () => {

    setIsPlaying(true)

    // get block times
    _prepareBlockTimes()
  }

  let _pauseMedia2 = () => {

    setIsPlaying(false)

    // clean up...
    if (myStreams && myStreams.length > 0) {
      for ( let i=0; i<myStreams.length; i++ ) {
        let _stream = myStreams[i]

        _stream.getTracks().forEach(function(track) {
          track.stop()
        })
      }
    }

    myRecorder = null
  }

  // play
  let _playMedia = async() => {

    if (!playerRef || !playerRef.current) {
      return
    }
    if ( isPlaying === true ) {
      return
    }
    setIsPlaying(true)

    // get block times
    let _blockTimes = _prepareBlockTimes()

    // 一つのspanが改行されてしまっていると
    // playIconStartIndexが 5 でも
    // 実際には 4 ということが発生する

    let _start = 0
    let _index_from_texts = 0

    // check texts
    for (let i=0; i<blockTimes.length; i++) {
      let _blocktime = blockTimes[i]
      if (_blocktime.text == playIconStartTexts) {
        _start = _blocktime.start
        _index_from_texts = _blocktime.index
        break
      }
    }

    if ( _start === 0 ) {
      for (let i=0; i<blockTimes.length; i++) {
        let _blocktime = blockTimes[i]
        if (_blocktime.index >= playIconStartIndex) {
          _start = _blocktime.start
          break
        }
      }
    } else {
      if (_index_from_texts !== playIconStartIndex) {

        setPlayIconStartDiff({
          from_index: _index_from_texts,
          diff: playIconStartIndex-_index_from_texts
        })
      }
    }

    // wait
    await _wait({ msec: 500 })

    playerRef.current.setAudioTimestamp(_start)
    playerRef.current.playAudio()
  }

  // prepare block times
  let _prepareBlockTimes = () => {

    if (!editorRef.current) {
      return
    }

    let editor_width = 0
    if (editorRef.current) {
      editor_width = widthRef.current.offsetWidth
    } else {
      console.log("no widthRef")
      return
    }

    // get block timestamps
    let blocks =  editorRef.current.getBlocks()

    let _blockTimes = blockTimes

    for ( let i=0; i<blocks.length; i++ ) {
      let _item = blocks[i]

      if (_item.data && _item.data.time0) {

        let time0 = _item.data.time0

        if ( time0.indexOf("dummy") === -1 ) {
          let time1 = time0.split("___")[0]
          let time2 = time1.split("@")[0]
          let start = parseFloat(time2.split("~")[0])
          let end = parseFloat(time2.split("~")[1])

          // calculate width
          let _span = document.createElement('span');
          _span.setAttribute("style", "font-size: 20px;");
          _span.innerText = _item.text
          document.body.appendChild(_span);
          let _span_w = _span.getBoundingClientRect().width
          document.body.removeChild(_span);

          let line_count = Math.ceil(_span_w / editor_width)

          // let line_count = 1

          _blockTimes.push({
            text: _item.text,
            index: i,
            start: start,
            end: end,
            line_count: line_count,
          })
        }
      }
    }

    // set block timestamps ...
    setBlockTimes(_blockTimes)

    return _prepareBlockTimes
  }


  // react-video subscribe state change
  useEffect(() => {

    if (!playerRef.current) {
      return
    }

    let _blockTimes = blockTimes

    let _line_diff = 0

    for (let i=0; i<_blockTimes.length; i++) {
      let _item = _blockTimes[i]
      let _start = _item.start
      let _end = _item.end
      let _index = _item.index

      let _line_count = _item.line_count
      _line_diff = _line_diff + _line_count - 1

      if (playerCurrentTime > _start && playerCurrentTime < _end) {

        _index = _index + _line_diff

        setPlayingBlockIndex(_index)

        break
      }
    }

  }, [playerCurrentTime, playerRef.current]);

  // add vocabs to custom dictionary
  let _addVocabsToCustomDictonary = async (draftjs_obj ) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.addVocabsToCustomDictonary({
        draftjs_obj: draftjs_obj,
        login_token: props.login_token,
        api_key_id: props.apiIdSelected,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      props.showAlert("辞書登録成功", "success")

      props.getVocabListAgain(props.apiIdSelected)

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)

  }


  // set ypos and start time
  let _setYPos = ({
    relativeY,
    texts,
  }) => {

    let domRect = editorPositionRef.current.getBoundingClientRect();

    let _margin = relativeY - domRect.top + 4

    setPlayIconMarginTop(_margin)

    let _index = parseInt(_margin / 30)

    setPlayIconStartIndex(_index)
    setPlayIconStartTexts(texts)
  }

  // _checkWord
  let _checkWord = async (fixed_words, fixed_list1) => {

    props.setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.checkPotentialDictVocab({
        fixed_words: fixed_words,
        fixed_blocks: fixed_list1,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      props.setLoading(false)

      if (results_1.trimmed_words) {
        return results_1.trimmed_words
      }

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")

      props.setLoading(false)
    }
  }

  //
  // record voice...
  //

  // use mic only
  let _init_stream_mic = async () => {

    if ( recording === true ) {
      props.showAlert("録音中は設定を変更できません", "error")
      return
    }

    setVideoStreamType("mic")

    let stream = await _getMediaConstraints({
      audio: true,
      video: false,
    })

    // init stream
    _init_stream({
      stream: stream,
      type: 'mic',
    })
  }

  // init stream
  let _init_stream = async ({
    stream,
    type,
  }) => {

    if (!stream) {
      // capture video

      try {
        stream = await _getMediaConstraints({
          audio: true,
          video: true,
        })

      } catch (err) {
        console.log("err: ", err)
      }
    }

    // // set stream
    // dispatch(UserActions.setStreams({
    //   streams: [stream]
    // }))

    setMyStreams([stream])

    if (type === "mic") {
      myRecorder = new RecordRTCPromisesHandler(stream, {
        type: 'audio',
        // mimeType: 'audio/webm',
      })
    } else {
      myRecorder = new RecordRTCPromisesHandler(stream, {
        type: 'video',
      })
    }
  }


  // start recording
  let _startRecording = async () => {

    if (recording === true) {
      return
    }
    setRecording(true)

    if (!myRecorder) {

      setRecordingStatus("preparing")

      await _init_stream_mic()

      await _wait({ msec: 1000 })
    }

    // if (recording === true) {
    //   return
    // }

    // setRecording(true)
    setRecordingStatus("recording")
    setStartTimestamp(new Date().getTime())

    myRecorder.startRecording()
  }

  // wait a second
  let _wait = ({ msec }) => {
    return new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve()
      }, msec);
    })
  }

  // stop rtc
  let _stopRtc = ( _Recorder ) => {
    return new Promise((resolve, reject) => {
      _Recorder.stopRecording( () => {
        resolve()
      } )
    })
  }

  let _stopRecording = async() => {

    props.setLoading(true)

    await _wait({ msec: 750 })

    // await myRecorder.stopRecording();
    await myRecorder.stopRecording();

    props.setLoading(false)

    let _duration = (new Date().getTime() - startTimestamp)/1000
    setStartTimestamp(-1)
    setAudioDuration(_duration)

    // let blob = myRecorder.getBlob();
    // let blob = await myRecorder.getBlob();
    let blob = await myRecorder.getBlob();
    setMyBlob(blob)

    // set media url
    setMediaUrl(URL.createObjectURL(blob))

    myRecorder.destroy()

    setRecording(false)
    setRecordingStatus("none")

    props.setLoading(false)

    // save test
    // RecordRTC.invokeSaveAsDialog(blob, 'video.webm');

    // stop all
    await _wait({ msec: 1000 })

    if (myStreams && myStreams.length > 0) {
      for ( let i=0; i<myStreams.length; i++ ) {
        let _stream = myStreams[i]
        _stream.getTracks().forEach(function(track) {
          track.stop()
        })
      }
    }

    myRecorder = null
  }

  // _delete
  let _delete = async () => {

    // delete blob
    setMyBlob(null)

    setStartTimestamp(-1)

    setAudioDuration(0)

    // setVideoStreamType("mic")
    // _init_stream_mic()

    setMediaUrl("")

    setTranscribed(false)

    setTranscriptDraftjsRaw({
      blocks: [],
      entityMap: {},
    })

    setBlockTimes([])

    setSelectedFile(null)

    // stop all
    await _wait({ msec: 1000 })
    if (myStreams && myStreams.length > 0) {
      for ( let i=0; i<myStreams.length; i++ ) {
        let _stream = myStreams[i]
        _stream.getTracks().forEach(function(track) {
          track.stop()
        })
      }
    }
  }

  // get media constraints
  let _getMediaConstraints = (param) => {

    return new Promise((resolve, reject) => {

      if (navigator.getDisplayMedia) {

        navigator.getDisplayMedia(param).then(async function(stream) {

          resolve(stream)
        });
      } else if (navigator.mediaDevices.getUserMedia) {

        navigator.mediaDevices.getUserMedia(param).then(async function(stream) {

          resolve(stream)
        });
      } else {
        reject("no media device")
      }
    })
  }

  // download scripts after saving custom dictinary
  let _downloadScripts = async ({
    draftjs_orig,
    draftjs_fixed,
  }) => {

    props.setLoading(true)

    try {

      // let ai_api_key = ""
      // for ( let i=0; i<props.deepSpeechTokens.length; i++ ) {
      //   let _item = props.deepSpeechTokens[i]
      //   if (_item._id === props.apiIdSelected) {
      //     ai_api_key = _item.api_key
      //     break
      //   }
      // }
      // if (!ai_api_key) {
      //   props.showAlert("api_key not found", "error")
      //   return
      // }
      // console.log("addVocabsToCustomDictonary2:1")
      //
      // // get evaluation masters
      // const results_1 = await MyAPI.addVocabsToCustomDictonary2({
      //   draftjs_orig: draftjs_orig,
      //   draftjs_fixed: draftjs_fixed,
      //   ai_api_key: ai_api_key,
      // })
      // if (results_1.status !== "success") {
      //   throw Error(results_1.message)
      // }

      await _updateDictionary({
        draftjs_orig: draftjs_orig,
        draftjs_fixed: draftjs_fixed,
        showAlert: false,
      })

      // create scripts
      let _now = new Date()
      let _year = _now.getFullYear()
      let _month = _now.getMonth() + 1
      if (_month < 10) {
        _month = "0"+_month
      } else {
        _month = _month.toString()
      }
      let _date = _now.getDate()
      if (_date < 10) {
        _date = "0"+_date
      } else {
        _date = _date.toString()
      }
      let _hours = _now.getHours()
      if (_hours < 10) {
        _hours = "0"+_hours
      } else {
        _hours = _hours.toString()
      }
      let _minutes = _now.getMinutes()
      if (_minutes < 10) {
        _minutes = "0"+_minutes
      } else {
        _minutes = _minutes.toString()
      }
      let _second = _now.getSeconds()
      if (_second < 10) {
        _second = "0"+_second
      } else {
        _second = _second.toString()
      }

      let fileContent = ""

      let _blocks = draftjs_fixed.blocks
      for ( let i=0; i<_blocks.length; i++ ) {
        let _block = _blocks[i]

        let _text = _block.text

        let _start = "[UNK] "

        if (_block.data && _block.data.time0) {
          let _time0 = _block.data.time0
          if (_time0.indexOf("dummy") === -1) {
            let _arr1 = _time0.split("___")
            let _arr2 = _arr1[0].split("@")
            _start = "["+parseFloat(_arr2[0].split("~")[0]).toFixed(2)+"] "
          }
        }

        fileContent = fileContent + _start + _text + "\n"
      }
      fileContent = fileContent.trim()

      let fileName = _year+_month+_date+_hours+_minutes+".txt"
      // var fileContent = "Page content...";
      // let myFile = new Blob([fileContent], {type: 'text/plain'});


      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileContent));
      element.setAttribute('download', fileName);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);


    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)
  }

  // update dictionary
  let _updateDictionary = async ({
    draftjs_orig,
    draftjs_fixed,
    showAlert,
  }) => {

    props.setLoading(true)

    try {

      let ai_api_key = ""
      for ( let i=0; i<props.deepSpeechTokens.length; i++ ) {
        let _item = props.deepSpeechTokens[i]
        if (_item._id === props.apiIdSelected) {
          ai_api_key = _item.api_key
          break
        }
      }
      if (!ai_api_key) {
        props.showAlert("api_key not found", "error")
        return
      }

      // get evaluation masters
      const results_1 = await MyAPI.addVocabsToCustomDictonary2({
        draftjs_orig: draftjs_orig,
        draftjs_fixed: draftjs_fixed,
        ai_api_key: ai_api_key,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      if (showAlert === true) {
        props.showAlert("カスタム辞書OK", "success")
      }

    } catch (err) {
      console.log("err: ", err )

      props.showAlert(err.message, "error")
    }

    props.setLoading(false)
  }


  // save audio
  let _saveAudio = () => {

    // create scripts
    let _now = new Date()
    let _year = _now.getFullYear()
    let _month = _now.getMonth() + 1
    if (_month < 10) {
      _month = "0"+_month
    } else {
      _month = _month.toString()
    }
    let _date = _now.getDate()
    if (_date < 10) {
      _date = "0"+_date
    } else {
      _date = _date.toString()
    }
    let _hours = _now.getHours()
    if (_hours < 10) {
      _hours = "0"+_hours
    } else {
      _hours = _hours.toString()
    }
    let _minutes = _now.getMinutes()
    if (_minutes < 10) {
      _minutes = "0"+_minutes
    } else {
      _minutes = _minutes.toString()
    }
    let _second = _now.getSeconds()
    if (_second < 10) {
      _second = "0"+_second
    } else {
      _second = _second.toString()
    }

    let _filename = _year+_month+_date+_hours+_minutes+".ogg"

    RecordRTC.invokeSaveAsDialog(myBlob, _filename);
  }

  return (
    <div style={{
      fontSize: 20,
      marginBottom: 20,
    }}>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>

        <Col md="12" xs="12" style={{
          textAlign: 'center',
        }}>

          {mediaUrl && (
            <div style={{
              position: 'relative',
              width: '100%',
            }}>

              <AudioController
                pauseMedia={_pauseMedia2}
                playMedia={_playMedia2}
                setPlayerCurrentTime={setPlayerCurrentTime}
                setIsPlaying={setIsPlaying}
                ref={playerRef}
                mediaUrl={mediaUrl} />

            </div>
          )}

          </Col>
        </Row>


        {/* record voice... */}
        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <Col md="2" xs="12" />

          <Col md="8" xs="12">

            <div className="shadow2dp" style={{
              backgroundColor: 'white',
              padding: 20,
            }}>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>

              <Col md="6" xs="12" style={{
                textAlign: 'center',
              }}>

                {myBlob === null && recordingStatus === "preparing" && (
                  <div style={{
                    height: 40,
                  }}>
                    <span className="blink_me" style={{
                      marginLeft: 10,
                      marginRight: 10,
                      fontSize: 22,
                      color: 'orange',
                    }}>
                      準備中…
                    </span>
                  </div>
                )}

                {myBlob === null && recordingStatus == "recording" && (
                  <div style={{
                    height: 40,
                  }}>
                    <span className="blink_me" style={{
                      marginLeft: 10,
                      marginRight: 10,
                      fontSize: 22,
                    }}>
                      録音中
                    </span>
                  </div>
                )}

                {myBlob && (
                  <div style={{
                    height: 40,
                  }}>
                    <br />
                  </div>
                )}

                {myBlob === null && recordingStatus === "none" && (
                  <div style={{
                    height: 40,
                  }}>
                    <br />
                  </div>
                )}

                {myBlob === null && recording === false && (
                  <span onClick={_startRecording} style={{
                    padding: 10,
                    borderRadius: 22,
                    borderColor: 'navy',
                    borderWidth: 3,
                    borderStyle: 'solid',
                    cursor: 'pointer',
                    marginTop: 10,
                  }}>
                    <FontAwesomeIcon
                      icon="microphone"
                      style={{
                        color: 'navy',
                        fontSize: 22,
                        cursor: 'pointer',
                    }}/>
                    <span style={{
                      marginLeft: 8,
                      marginRight: 8,
                      cursor: 'pointer',
                      fontSize: 22,
                    }}>

                      録画開始
                    </span>
                  </span>
                )}

                {myBlob === null && recording == true && (

                  <span onClick={_stopRecording} style={{
                    padding: 10,
                    borderRadius: 22,
                    borderColor: 'navy',
                    borderWidth: 3,
                    borderStyle: 'solid',
                    cursor: 'pointer',
                  }}>

                    <FontAwesomeIcon
                      icon="pause-circle"
                      style={{
                        color: 'navy',
                        fontSize: 22,
                        cursor: 'pointer',
                    }}/>
                    <span style={{
                      marginLeft: 8,
                      marginRight: 8,
                      cursor: 'pointer',
                      fontSize: 22,
                    }}>

                      録画停止
                    </span>


                  </span>
                )}

                {myBlob !== null && isPlaying === false && (

                  <span onClick={_delete} style={{
                    padding: 10,
                    borderRadius: 22,
                    borderColor: '#777777',
                    borderWidth: 3,
                    borderStyle: 'solid',
                    cursor: 'pointer',
                  }}>

                    <FontAwesomeIcon
                      icon="trash"
                      style={{
                        color: '#777777',
                        fontSize: 22,
                        cursor: 'pointer',
                    }}/>
                    <span style={{
                      marginLeft: 8,
                      marginRight: 8,
                      cursor: 'pointer',
                      fontSize: 22,
                    }}>
                      削除
                    </span>
                  </span>
                )}

              </Col>


              <Col md="6" xs="12">
                {selectedFile ? (
                  <div>
                    <div style={{ height: 40, }}/>
                    {selectedFile.name}
                  </div>
                ) : (
                  <div>
                    <UploadAudioDiv fileSlected={_fileSlected} />
                    {/*<UploadAudioDiv fileSlected={() => {}}/>*/}
                  </div>
                )}
              </Col>

            </Row>

            {/* step 4 edit transcript */}
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col md="6" xs="12" />
              <Col md="6" xs="12" style={{
                textAlign: 'right',
              }}>

              {myBlob !== null && (
                <Button
                  onClick={_transcribe2}
                  color="primary"
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                  }}>

                    <FontAwesomeIcon
                      icon="magic"
                      style={{
                        marginRight: 6,
                    }}/>

                    <span style={{
                      marginLeft: 6,
                    }}>
                      文字起こしする
                    </span>
                  </Button>
              )}


              </Col>
            </Row>

          </div>
        </Col>

        <Col md="2" xs="12" />
      </Row>

      {/* calculate width */}
      <Row>
        <Col md="2" xs="12" />
        <Col md="8" xs="12">
          <div ref={widthRef} style={{
            width: '100%',
            height: 1,
          }} />
        </Col>
        <Col md="2" xs="12" />
      </Row>


      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>

        <Col md="1" xs="12" style={{
          textAlign: 'right',
        }}>
          {transcribed === true && isPlaying === true && (
            <img src={soundwave} style={{
              width: 60,
              height: 60,
              fontSize: 15,
              // cursor: 'pointer',
              marginLeft: 60,
              marginRight: 10,
              color: '#777777',
              marginTop: 4 + playingBlockIndex * 30,
            }} alt="soundwave" />
          )}

        </Col>

        <Col md="1" xs="12" style={{
          textAlign: 'right',
        }}>

          {transcribed === true  && (
            <FontAwesomeIcon
              onClick={() => _togglePlayMedia()}
              icon={isPlaying === true ? 'pause' : 'play'}
              style={{
                fontSize: 15,
                cursor: 'pointer',
                marginLeft: 10,
                marginRight: 10,
                color: '#777777',
                marginTop: playIconMarginTop,
            }}/>
          )}

        </Col>

        <Col md="8" xs="12">

        {/* draftjs editor and submit btn */}
        {myBlob !== null && (
          <DemoEditor
            ref={editorRef}
            transcribed={transcribed}
            saveAudio={_saveAudio}
            downloadScripts={_downloadScripts}
            updateDictionary={_updateDictionary}
            addVocabsToCustomDictonary={_addVocabsToCustomDictonary}
            setYPos={_setYPos}
            showAlert={props.showAlert}
            mojiokoCount={mojiokoCount}
            checkWord={_checkWord}
            transcriptDraftjsRaw={transcriptDraftjsRaw} />
        )}

        </Col>
        <Col md="2" xs="12">
          <div ref={editorPositionRef} />
        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="2" xs="12" />
        <Col md="8" xs="12" style={{
          fontSize: 14,
        }}>
          <span>
            カスタム辞書簡単作成エディタは実際の音声をドラッグ、文字起こし、修正を行うことで簡単にカスタム辞書を作成できるツールです。
            録音した音声や編集したテキストのダウンロードも出来ます。
            <br/>
            ※ 通常のAPI利用料が発生します
          </span>
        </Col>
        <Col md="2" xs="12" />
      </Row>

    </div>
  )
}
export default AudioMagicEditor
